import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slider from "@material-ui/core/Slider";
import Switch from "@material-ui/core/Switch";

import RbGrid from "components/RbGrid";
import RbInputLabel from "components/RbInputLabel";
import RbRadioGroupControl from "components/RbRadioGroupControl/RbRadioGroupControl";
import RbThemeConfigContext from "components/RbThemeConfigProvider/RbThemeConfigContext";

import ColorControl from "./ColorControl";

const colors = [
  "#E91E63",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
  "#2196F3",
  "#009688",
  "#4CAF50",
  "#CDDC39",
  "#FFEB3B",
  "#FF9800",
  "#FF5722",
  "#795548",
];

const fontSizeOptions = [
  { label: "Small", value: "small" },
  { label: "Medium", value: "medium" },
  { label: "Large", value: "large" },
];

function ConfigModal(props) {
  const {
    primaryColor,
    dark,
    contrast,
    fontSize,
    handleChangePrimaryColor,
    handleToggleDark,
    handleChangeContrast,
    handleChangeFontSize,
  } = React.useContext(RbThemeConfigContext);

  return (
    <Dialog fullWidth hideBackdrop {...props}>
      <DialogTitle>Configuration</DialogTitle>
      <DialogContent>
        <RbGrid container rowGap={5}>
          <RbGrid item xs={12}>
            <ColorControl
              value={primaryColor}
              onChange={handleChangePrimaryColor}
              colors={colors}
            />
          </RbGrid>
          <RbGrid item xs={12}>
            <RbRadioGroupControl
              label="Font size"
              options={fontSizeOptions}
              variant="row"
              value={fontSize}
              onChangeValue={handleChangeFontSize}
              columnGap={4}
            />
          </RbGrid>
          <RbGrid item xs={12}>
            <RbInputLabel>Contrast</RbInputLabel>
            <Slider
              aria-labelledby="continuous-slider"
              value={contrast}
              onChange={handleChangeContrast}
            />
          </RbGrid>
          <RbGrid item xs={12}>
            <RbInputLabel>Dark</RbInputLabel>
            <Switch
              checked={dark}
              onChange={handleToggleDark}
              color="primary"
            />
          </RbGrid>
        </RbGrid>
        <br />
      </DialogContent>
    </Dialog>
  );
}

export default React.memo(ConfigModal);
